import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// import ActiveCompany from "./pages/AdminPages/Company/Aactive/ActiveOrders";
import ActiveOrders from "./pages/AdminPages/Company/Aactive/ActiveOrders";
import ActualLoss from "./pages/AdminPages/Process Loss/ActualLoss";
import AddBanner from "./pages/AdminPages/Banner Content/AddBanner";
import AddEditCategories from "./pages/AdminPages/Categories/AddEditCategories";
// import AdminReports from "./pages/AdminPages/AdminReports/AdminReports";
import AllocatedOrders from "./pages/Delivery Management/AllocatedOrders/AllocatedOrders";
import BannerCarousal from "./pages/AdminPages/Banner Content/BannerCarousal";
import BannerContent from "./pages/AdminPages/Banner Content/BannerContent";
import Categories from "./pages/AdminPages/Categories/Categories";
import CategoriesStepProgressForm from "./pages/AdminPages/Categories/CategoriesStepProgressForm";
import CompanyStepProgressForm from "./pages/AdminPages/Company/Aactive/CompanyStepProgressForm";
import CreateOrder from "./pages/Orders/Outbox/CreateOrder";
import CreateProduct from "./pages/AdminPages/Products/CreateProduct";
import CreateTRF from "./pages/SourceVerification/TrfAllUser/CreateTRF";
import Dashboard from "./pages/Dashboards/Dashboard";
import DefinedLoss from "./pages/AdminPages/Process Loss/DefinedLoss";
import DeliveryBoy from "./pages/Delivery Management/DeliveryBoy/DeliveryBoy";
import DropPoints from "./pages/Delivery Management/Drop-Points/DropPoints";
import EditBanner from "./pages/AdminPages/Banner Content/EditBanner";
import EditOrder from "./pages/Orders/Outbox/EditOrder";
import EditPendingCompany from "./pages/AdminPages/Company/Pending/EditPendingCompany";
import EditPendingContact from "./pages/AdminPages/Company/Pending/EditPendingContact";
import EditPendingLocation from "./pages/AdminPages/Company/Pending/EditPendingLocation";
import EditPendingRefrredBy from "./pages/AdminPages/Company/Pending/EditPendingRefrredBy";
import EditPendingUsers from "./pages/AdminPages/Company/Pending/EditPendingUsers";
import EditdefinedLoss from "./pages/AdminPages/Process Loss/EditdefinedLoss";
import LoginFrom from "./pages/Authentication/LoginFrom";
import MainLayout from "./components/Layouts/MainLayout";
import ManagersManagement from "./pages/Delivery Management/Managers/Managers";
import MyProfileEditPage from "./pages/MyProfile/MyProfileEditPage";
import MyProfileLandingPage from "./pages/MyProfile/MyProfileLandingPage";
import NewDeliveryBoys from "./pages/Delivery Management/DeliveryBoy/NewDeliveryBoys";
import OrdersInboxComponent from "./pages/Orders/Inbox/OrdersInboxComponents";
import OrdersOutboxComponent from "./pages/Orders/Outbox/OrdersOutboxComponents";
import PartnerProfileLandingPage from "./pages/PartnerProfile/PartnerProfileLandingPage";
import PendingCompany from "./pages/AdminPages/Company/Pending/PendingOrders";
import ProductMainComponents from "./pages/AdminPages/Products/ProductMainComponent";
import PublicLayout from "./components/Layouts/PublicLayout";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import RegistrationStepProgress from "./pages/Authentication/RegistrationStepProgress";
import RequestTags from "./pages/RequestTags/RequestTags";
import ReviewActiveCompany from "./pages/AdminPages/Company/Aactive/ReviewActiveCompany";
import ReviewCategory from "./pages/AdminPages/Categories/ReviewCategories";
import ReviewPartnerProfile from "./pages/PartnerProfile/ReviewPartnerProfile";
import ReviewPendingCompany from "./pages/AdminPages/Company/Pending/ReviewPendingCompany";
import ShipmentInboxComponent from "./pages/Shipment/Inbox/ShipmentInboxComponents";
import ShipmentMainComponent from "./pages/Shipment/ShipmentMainComponents";
import ShipmentOutboxComponent from "./pages/Shipment/Outbox/ShipmentOutboxComponents";
import ShipmentStepProgress from "./pages/Shipment/Outbox/ShipmentStepProgress";
import SourceVerification from "./pages/SourceVerification/TrfAllUser/SourceVerification";
import StepProgressOrder from "./pages/Orders/Outbox/StepProgress";
import Stock from "./pages/Stock/StockComponent";
import { Toaster } from "react-hot-toast";
import Traceability from "./pages/Traceability/Traceability";
import TrfUser from "./pages/SourceVerification/TrfUser/TrfUser";
import UnallocatedOrders from "./pages/Delivery Management/NotAllocatedOrders/UnallocatedOrders";
import UserMainComponent from "./pages/AdminPages/Users/UserMainComponent";
import UsersManagement from "./pages/Delivery Management/UsersManagment/UsersManagement";
import VehiclesManagement from "./pages/Delivery Management/Vehicles/Vehicles";
import ViewOrder from "./pages/Orders/Outbox/ViewOrderOutbox";
import ViewOrderInbox from "./pages/Orders/Inbox/ViewOrderInbox";
import ViewProduct from "./pages/AdminPages/Products/ViewProduct";
import ViewShipmentInbox from "./pages/Shipment/Inbox/ViewShipment";
import ViewShipmentOutbox from "./pages/Shipment/Outbox/ViewShipment";
import ViewTRF from "./pages/SourceVerification/ViewTRF";
import ViewTags from "./pages/RequestTags/ViewTags";
import { useSelector } from "react-redux";
import LoginForm from "./pages/Authentication/LoginFrom";
import CouponList from "./pages/AdminPages/Coupen/CoupenList";
import CouponForm from "./pages/AdminPages/Coupen/AddEditCoupen";
import Festival from "./pages/AdminPages/Festival/Festival";
import AddEditFestival from "./pages/AdminPages/Festival/AddEditFestival";
import ReviewFestival from "./pages/AdminPages/Festival/ReviewFestival";

// import GlobalStyles from "./styles/GlobalStyles";
// import Dashboard from "./pages/Dashboard";
// import Login from "./pages/Login";
// import PageNotFound from "./pages/PageNotFound";

// import 'react-toastify/dist/ReactToastify.css';
// import { ToastContainer } from 'react-toastify';
// import StepProgressBusinessUnit from "./pages/AdminPages/Business Unit/StepProgress";

// import AddLot from "./pages/Shipment/Outbox/AddLot"

// import BusinessUnit from "./pages/AdminPages/Business Unit/Categories";

// import BusinessUnitStepProgressForm from "./pages/AdminPages/Business Unit/CategoriesStepProgressForm";

// import AddEditBusinessUnitCompany from "./pages/AdminPages/Categories/AddEditBusinessUnitCompany";

// import { MyProfileEditPage } from "./pages/MyProfile/MyProfileEditPage";

// import UserRoutes from "./routes/UsersRoutes";
// import AdminRoute from "./routes/AdminRoutes";

// import ActiveOrders from "./pages/AdminPages/Company/Aactive/ActiveOrders";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 60 * 1000,
      staleTime: 0,
    },
  },
});
function App() {
  console.log("App.js");

  const bannerOpen = useSelector((state) => state.auth.bannerOpen);

  return (
    <QueryClientProvider client={queryClient}>
      {/* //   <ReactQueryDevtools initialIsOpen={true} /> */}
      {bannerOpen ? <BannerCarousal show={bannerOpen} /> : null}
      {/* <GlobalStyles /> */}
      <BrowserRouter>
        <Routes>
          {/* All Users */}

          <Route element={<MainLayout className="foo" />}>
            <Route path="ok-delivery-boy" element={<NewDeliveryBoys />} />
            <Route path="unchecked-delivery-boy" element={<DeliveryBoy />} />
            <Route path="assigned-orders" element={<AllocatedOrders />} />
            <Route path="unassigned-orders" element={<UnallocatedOrders />} />
            <Route path="dashboard" element={<ActiveOrders />} />
            <Route path="managers-list" element={<ManagersManagement />} />
            <Route path="user-management" element={<UsersManagement />} />
            <Route path="drop-point-list" element={<DropPoints />} />
            <Route
              path="manager-profile"
              element={<PartnerProfileLandingPage />}
            />
            <Route path="vehical-list" element={<VehiclesManagement />} />

            {/* Pushpa List */}

            <Route path="product-category" element={<Categories />} />
            <Route path="products-list" element={<Categories />} />
            {/* <Route path="view-product/:productId" element={<ViewProduct />} /> */}
            {/* <Route
              path="edit-products/:productId"
              element={<CreateProduct />}
            /> */}
            <Route path="festival-list" element={<Festival />} />
            <Route
              path="/edit-festival-date/:festivalId"
              element={<AddEditFestival />}
            />
            <Route
              path="/view-festival-details/:festivalId"
              element={<ReviewFestival />}
            />
            <Route path="create-festival/" element={<AddEditFestival />} />
            <Route path="discount-list" element={<Categories />} />
            <Route path="discount-banner-content" element={<BannerContent />} />
            <Route path="discount-banners" element={<BannerContent />} />
            <Route path="discount-banner/edit" element={<EditBanner />} />
            <Route path="discount-banner/add" element={<AddBanner />} />
            <Route
              path="discount-banner-carousel"
              element={<BannerCarousal />}
            />
            {/* <Route path="my-profile" element={<MyProfileLandingPage />} /> */}

            {/* <Route path="tracebility" element={<Traceability />} />
            <Route path="inbox-order" element={<OrdersInboxComponent />} />
            <Route path="outbox-order" element={<OrdersOutboxComponent />} />
            <Route path="/create-order" element={<StepProgressOrder />} />
            <Route path="/details/:orderId" element={<ViewOrder />} /> */}
            <Route
              path="/view-order-inbox/:orderId"
              element={<ViewOrderInbox />}
            />
            <Route path="/edit-order-place/:orderId" element={<EditOrder />} />
            <Route
              path="/edit-product/:productId"
              element={<StepProgressOrder />}
            />

            {/* Admin routes */}
            {/* <Route element={<AdminRoute />}> */}
            <Route path="active-orders" element={<OrdersInboxComponent />} />
            <Route path="pending-orders" element={<PendingCompany />} />
            {/* <Route path="business-unit" element={<BusinessUnit />} /> */}
            <Route path="users" element={<UserMainComponent />} />
            <Route path="products" element={<ProductMainComponents />} />
            <Route
              path="/create-company"
              element={<CompanyStepProgressForm />}
            />
            <Route path="regular-plan" element={<ActualLoss />} />
            <Route path="special-plan" element={<DefinedLoss />} />
            <Route path="/edit-special-plan" element={<EditdefinedLoss />} />
            {/* <Route path="admin-reports" element={<AdminReports />} /> */}
            <Route path="coupen-list" element={<CouponList />} />
            <Route
              path="review-active-orders/:companyId"
              element={<ReviewActiveCompany />}
            />
            <Route
              path="review-pending-orders/:companyId"
              element={<ReviewPendingCompany />}
            />
            <Route
              path="edit-company-details/:companyId"
              element={<EditPendingCompany />}
            />
            <Route
              path="edit-contact-details/:companyId"
              element={<EditPendingContact />}
            />
            <Route
              path="edit-user-details/:companyId"
              element={<EditPendingUsers />}
            />
            <Route
              path="edit-location-details/:companyId"
              element={<EditPendingLocation />}
            />
            <Route
              path="edit-refrred-details/:companyId"
              element={<EditPendingRefrredBy />}
            />

            <Route path="inbox-shipment" element={<ShipmentInboxComponent />} />
            <Route
              path="/outbox-shipment"
              element={<ShipmentOutboxComponent />}
            />
            <Route path="/create-shipment" element={<ShipmentStepProgress />} />
            <Route
              path="/view-details/:shipmentId"
              element={<ViewShipmentInbox />}
            />
            <Route
              path="/view-details-outbox/:shipmentId"
              element={<ViewShipmentOutbox />}
            />
            <Route path="/edit-shipment" element={<ShipmentStepProgress />} />
            <Route
              path="/view-order-inbox/:orderId"
              element={<ViewOrderInbox />}
            />
            <Route
              path="/edit-order/:orderId"
              element={<StepProgressOrder />}
            />
            <Route
              path="/edit-product/:productId"
              element={<StepProgressOrder />}
            />
            <Route path="active-orders" element={<OrdersInboxComponent />} />
            <Route path="pending-orders" element={<PendingCompany />} />
            <Route
              path="/edit-active-orders/:companyId/:step/:actionType/"
              element={<CompanyStepProgressForm />}
            />
            {/* Route for Create Business unit */}
            {/* <Route path="/create-categories" element={<StepProgressBusinessUnit />} /> */}
            <Route
              path="/create-categories"
              element={<CategoriesStepProgressForm />}
            />
            <Route
              path="/view-product-category/:categoryId"
              element={<ReviewCategory />}
            />
            <Route
              path="/edit-product-category/:categoryId"
              element={<AddEditCategories />}
            />
            {/* <Route
              path="/edit-product-category/l/:companyBuId"
              element={<AddEditBusinessUnitLocation />}
            />
            <Route
              path="/edit-product-category/c/:companyBuId"
              element={<AddEditBusinessUnitContact />}
            /> */}
            <Route path="users" element={<UserMainComponent />} />
            <Route path="products" element={<ProductMainComponents />} />
            <Route path="regular-plan" element={<ActualLoss />} />
            <Route path="special-plan" element={<DefinedLoss />} />
            <Route path="coupen-list" element={<CouponList />} />
            <Route path="/create-coupon" element={<CouponForm />} />
            <Route path="/edit-coupon/:couponId" element={<CouponForm />} />
            {/* <Route path="banner-content" element={<BannerContent />} />  */}

            <Route path="create-product" element={<CreateProduct />} />
            <Route path="view-product/:productId" element={<ViewProduct />} />
            <Route
              path="edit-products/:productId"
              element={<CreateProduct />}
            />

            <Route path="edit-my-profile" element={<MyProfileEditPage />} />
            <Route
              path="/view-partner-profile/:companyId"
              element={<ReviewPartnerProfile />}
            />

            <Route path="trf" element={<TrfUser />} />
          </Route>
          {/* Wrap your public routes with PublicLayout */}
          {/* Public */}
          <Route element={<PublicLayout />}>
            <Route index element={<LoginForm />} />
            <Route path="login" element={<LoginFrom />} />
            <Route path="/register" element={<RegistrationStepProgress />} />

            {/* <Route path="register" element={<YourRegisterComponent />} /> */}
            {/* Add additional public routes as needed */}
          </Route>

          {/* <Route path="*" element={<PageNotFound />} /> */}
        </Routes>
      </BrowserRouter>

      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 5000,
          },
          style: {
            fontSize: "16px",
            maxWidth: "500px",
            padding: "16px 24px",
            backgroundColor: "var(--color-grey-0)",
            color: "var(--color-grey-700)",
          },
        }}
      />
    </QueryClientProvider>
  );
}

export default App;
